// TODO: Max 1 class
import * as React from 'react';

import { IControlSchema, IControlSchemaBase } from '../../core/Controls';
import { Captions } from '../i18n/messages';

import {
  Dispatcher,
  IDispatcher,
  ValidationError,
} from '../helpers/Dispatcher';
import { Component, Handler, I18NString } from '../helpers/Utils';

import { Description } from './components/Description';

import { createTextBox } from './TextBox';
import { createDropBox, IDropBoxSchema } from '../../shared/ui/dropbox/DropBox';

const _controls: { [type: string]: Handler } = {
  TEXTBOX: createTextBox,
  TEXTAREA: createTextBox,
  DROPBOX: createDropBox,
};

export type ChangeHandler = (
  id: string,
  value: any,
  valid: boolean,
  error: ValidationError | undefined,
) => void;

// @ts-ignore
export class ObjectControlDispatcher extends Dispatcher {
  private change: ChangeHandler;

  constructor(change: Handler) {
    super();
    this.change = change;
  }

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  onVisit(id: string) {}

  // eslint-disable-next-line class-methods-use-this
  setError(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    id: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    value: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    error: { message: any },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    skipCommonValidation: boolean,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  ): void {}

  onChange(
    id: string,
    value: any,
    valid: boolean,
    error: ValidationError | undefined,
  ): void {
    this.change(id, value, valid, error);
  }

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  onBlur(id: string, value: any, valid: boolean): void {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  onLoadFile(id: string, files: Array<any>): void {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  onAddValueRefresh(id: string, value: any): void {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  pullValue(control_id: string) {}

  // eslint-disable-next-line class-methods-use-this,@typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
  pullTableRows(control_id: string, field_id: string): Array<string> {
    return [];
  }

  public lock(value: boolean) {
    this.invoke('lock', value);
  }

  public clear() {
    this.invoke('clear');
  }
}

export interface IObjectControlSchema extends IControlSchemaBase {
  description?: I18NString;
  controls: IControlSchema[];
  views: string[];
  value: any[];
}

export interface IObjectControlProps {
  schema: IObjectControlSchema;
  api: any;
}

export interface IObjectControlState {
  values: any[];
  currentValues: { [id: string]: { [key: string]: any } };
  active: boolean;
}

export class ObjectControl extends Component<
  IObjectControlProps,
  IObjectControlState
> {
  private viewControls: IControlSchema[];

  private dispatcher: ObjectControlDispatcher;

  state = {
    values: [],
    currentValues: {},
    active: false,
  };

  constructor(props) {
    super(props);

    this.dispatcher = new ObjectControlDispatcher(this.onChange);
  }

  componentDidMount() {
    this.viewControls = [];
    for (const control of this.props.schema.controls) {
      if (this.props.schema.views.indexOf(control.id) > -1) {
        this.viewControls.push(control);
      }
    }

    if (this.props.schema.value !== null) {
      this.setState({ values: this.props.schema.value });
    }
  }

  private getDisplayValue = (value: any, control: IControlSchema): any => {
    if (control.type.toUpperCase() === 'DROPBOX') {
      const dropBox = control as IDropBoxSchema;
      for (const opt of dropBox.options) {
        if (opt.key === value) {
          return this.tr(opt.value);
        }
      }
    }
    return value;
  };

  protected onChange = (id: string, value: any, valid: boolean) => {
    this.setState(({ currentValues }) => {
      const _currentValues = { ...currentValues };
      _currentValues[id] = { value, valid };

      if (valid) {
        for (const control of this.props.schema.controls) {
          const _value = _currentValues[control.id];

          if ((_value === undefined && control.required) || !_value.valid) {
            valid = false;
          }
        }
      }

      return {
        active: valid,
        currentValues: _currentValues,
      };
    });
  };

  protected onSend = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (this.state.active === false) {
      return;
    }

    this.dispatcher.lock(true);
    this.setState({ active: false });

    const _values: { [id: string]: any } = {};
    for (const control of this.props.schema.controls) {
      const value = this.state.currentValues[control.id];
      if (value !== undefined) _values[control.id] = value.value;
    }

    const timestamp = this.props.api.putValue(this.props.schema.id, _values, {
      success: (_params) => {
        this.setState(({ values }) => ({
          active: false,
          currentValues: {},
          values: [...values, { timestamp, value: _values }],
        }));

        this.dispatcher.lock(false);
        this.dispatcher.clear();
      },
      error: () => {
        this.dispatcher.lock(false);

        this.setState({ active: true });
      },
    });
  };

  private removeHandler = (timestamp: number): any => {
    const fn = (event: React.MouseEvent<any>) => {
      event.preventDefault();

      this.props.api.removeValue(this.props.schema.id, timestamp, {
        success: () => {
          this.setState(({ values }) => {
            const _values = { ...values };

            for (const value of _values) {
              if (value.timestamp === timestamp) {
                const ix = _values.indexOf(value);
                if (ix > -1) {
                  _values.splice(ix, 1);
                }
              }
            }
            return {
              values: _values,
            };
          });
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: () => {},
      });
    };
    return fn.bind(this);
  };

  private renderValues = (): React.ReactElement<any> => {
    if (this.state.values.length > 0) {
      const headers = [];
      for (const control of this.viewControls) {
        headers.push(<th>{this.tr(control.title)}</th>);
      }
      if (!this.props.api.isLocked())
        headers.push(<th className="row-controls" aria-label="пусто" />);

      const values: React.ReactElement<any>[] = [];
      for (const value of this.state.values) {
        const row = [];
        for (const control of this.viewControls) {
          const displayValue = this.getDisplayValue(
            value.value[control.id],
            control,
          );
          row.push(<td>{displayValue}</td>);
        }
        if (!this.props.api.isLocked()) {
          row.push(
            <td>
              <button
                onClick={this.removeHandler(value.timestamp)}
                className="btn btn-danger btn-mini"
              >
                <i className="icon-remove" />
              </button>
            </td>,
          );
        }
        values.push(<tr>{row}</tr>);
      }

      return (
        <table className="table table-striped table-bordered">
          <thead>
            <tr>{headers}</tr>
          </thead>
          <tbody>{values}</tbody>
        </table>
      );
    }
    return null;
  };

  render() {
    let description = null;
    if (this.props.schema.description !== null) {
      description = [
        // tslint:disable-next-line:jsx-key
        <span>&nbsp;</span>,
        // tslint:disable-next-line:jsx-key
        <Description text={this.props.schema.description} />,
      ];
    }

    const controls: React.ReactElement<any>[] = [];
    for (const control of this.props.schema.controls) {
      const handler = _controls[control.type.toUpperCase()];
      if (handler !== null) {
        controls.push(handler(control, this.props.api, this.dispatcher));
      }
    }

    let btnClassName = 'btn btn-primary';
    if (!this.state.active) btnClassName += ' disabled';

    return (
      <div>
        <label>
          {this.tr(this.props.schema.title)}
          {description}
        </label>
        {this.renderValues()}
        <div className="well">
          {controls}
          <div className="control-group text-right">
            <button className={btnClassName} onClick={this.onSend}>
              {this.tr(Captions.ADD)}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export function createObjectControl(
  schema: IControlSchema,
  api: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  dispatcher: IDispatcher = null,
): React.ReactElement<any> {
  return <ObjectControl schema={schema as IObjectControlSchema} api={api} />;
}
